var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0.212891V7.21289V32.2129H0V7.21289L7 0.212891H32Z",
    fill: "url(#paint0_linear_4244_147907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7061 20.7461L20.0551 17.4266C19.8825 17.2697 19.6558 17.1861 19.4227 17.1933C19.1895 17.2005 18.9684 17.298 18.8058 17.4652L16.6565 19.6755C16.1392 19.5767 15.0992 19.2525 14.0286 18.1846C12.958 17.1131 12.6338 16.0704 12.5377 15.5567L14.7462 13.4065C14.9136 13.2441 15.0113 13.0229 15.0185 12.7897C15.0257 12.5565 14.9419 12.3297 14.7848 12.1572L11.4662 8.5072C11.309 8.33418 11.0907 8.22923 10.8574 8.21464C10.6241 8.20005 10.3943 8.27697 10.2169 8.42906L8.2679 10.1005C8.11262 10.2563 8.01994 10.4637 8.00744 10.6834C7.99397 10.9079 7.7371 16.2267 11.8614 20.3527C15.4593 23.9497 19.9662 24.2129 21.2074 24.2129C21.3889 24.2129 21.5002 24.2075 21.5299 24.2057C21.7495 24.1934 21.9568 24.1003 22.1119 23.9443L23.7824 21.9945C23.9351 21.8176 24.0126 21.588 23.9983 21.3548C23.9841 21.1215 23.8792 20.9031 23.7061 20.7461V20.7461Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4244_147907",
    x1: -1.58138e-9,
    y1: 16.2129,
    x2: 31.9457,
    y2: 16.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBack);
export default __webpack_public_path__ + "static/media/phone-back.6239f9331dc922da905694a246908536.svg";
export { ForwardRef as ReactComponent };